import { useState, useCallback } from 'react';
export function useArrayState(defaultState = [], options = {}) {
  const [state, setState] = useState(defaultState);
  const addItem = useCallback(
    (item) => {
      setState((oldState) => {
        const stateCopy = options.singleSelect ? [] : [...oldState];
        stateCopy.push(item);
        return stateCopy;
      });
  }, []);
  const deleteItem = useCallback((item) => {
    setState((oldState) => [...oldState].filter((oldItem) => oldItem !== item));
  }, []);
  return [state, addItem, deleteItem, setState];
}
